export const TIMELINE_SIMULATOR_FORM2_CONSTANTS = {
  TIMELINE_CAMPAIGN_TYPES: {
    PRODUCT_CAMPAIGN: 'Product Campaign',
    HALLMARKS: 'Hallmarks',
  },

  TIMELINE_PRODUCT_LAUNCH_TYPES: {
    CHINA_NORMAL_COSMETICS: 'Product Launch China Normal Cosmetics',
    CHINA_SPECIAL_COSMETICS: 'Product Launch China Special Cosmetics',
    CHINA_SPECIAL_COSMETICS_NANO: 'Product Launch China Special Cosmetics with Nano',
    NOT_IN_CHINA: 'Product Launch not in China',
    NONE: 'No Product Launch Only Campaign',
  },

  CAMPAIGN_TYPES: {
    STANDARD: 'Standard',
    NEW_TERRITORY: 'New Territory',
    NONE: 'No Dedicated Campaign',
    REDDIT: 'Reddit',
  },

  COMPLEXITY_LEVELS: {
    ONE_TWO_T: '1T/2T',
    THREE_FOUR_T: '3T/4T',
    THREE_T: '3T',
    FOUR_T: '4T',
  },

  POSM_VALUES: {
    DMI_PRODUCED: 'DMI Produced',
    LOCALLY_PRODUCED: 'Locally Produced',
    NO: 'No',
  },

  HALLMARKS_TYPES: {
    GLOBAL_HALLMARKS: 'Global Hallmarks',
    HOLIDAY: 'Holiday',
    CHINA_SPECIFIC_HALLMARKS: 'China Specific Hallmarks',
  },

  //to use as key value of HALLMARK_TYPES
  HALLMARKS_TYPE_TEXTS: {
    'Global Hallmarks': 'Global Hallmarks (Not Holiday)',
    Holiday: 'Holiday',
    'China Specific Hallmarks': 'China Specific Hallmarks',
  },

  COLLECTOR_TYPES: {
    INCLUDE_FOR_CHINA: 'Include for China',
    NOT_FOR_CHINA: 'NotForChina',
    YES: 'Yes',
    NO: 'No',
  },

  SIMULATOR_CRITERIA_KEYS: {
    PROJECT_TYPE: 'Project Type',
    PRODUCT_LAUNCH_TYPE: 'Product Launch Type',
    COMPLEXITY: 'Complexity',
    CAMPAIGN_TYPE: 'Campaign Type',
    POSM: 'POSM',
    DMI_PRODUCED: 'DMI Produced',
    LOCALLY_PRODUCED: 'Locally Produced',
    HALLMARKS_TYPE: 'Hallmarks Type',
    COLLECTOR: 'Collector',
    INCLUDE_FOR_CHINA: 'Include for China',
    SET: 'Set',
    SET_DMI_PRODUCED: 'Set DMI Produced',
    SET_LOCALLY_PRODUCED: 'Set Locally Produced',
    POSM_DMI_PRODUCED: 'POSM DMI Produced',
    POSM_LOCALLY_PRODUCED: 'POSM Locally Produced',
    COMPANY_ID: 'Company ID',
    IS_THREE_STAR: 'Is Three Star',
    LAUNCH_POTENTIAL: 'Launch Potential',
  },

  FORM_COMPONENT_NAME: 'timeline-simulator-criteria-form2',
};
